import React from 'react'

export const CheckIcon = () => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.83286 14.8756C7.44219 15.2669 6.80811 15.2669 6.41745 14.8756L0.292388 8.74016C-0.0973057 8.34981 -0.0973428 7.71763 0.292306 7.32723L0.390019 7.22932C0.780666 6.83792 1.41482 6.83789 1.80551 7.22924L6.41745 11.849C6.80811 12.2403 7.44219 12.2403 7.83286 11.849L19.3688 0.293492C19.7595 -0.097863 20.3937 -0.0978272 20.7843 0.293574L20.882 0.391476C21.2717 0.781877 21.2716 1.41405 20.8819 1.80441L7.83286 14.8756Z"
        fill="currentColor"
      />
    </svg>
  )
}
